<template>
  <div class="label">
    <CreateOrEditAdminGoodBusiness
      :tagList="tagList"
      ref="createOrEditDialog"
      @submitDialog="GetTableList"
    />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>优选好商</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="HeaderButtons">
        <el-button type="primary" plain size="small" @click="RandomIndex()"
          >随机排序</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="CreateItem()"
          >{{l("新增")}}</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="6">
          <label>{{l("标题")}}</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.name"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>

        <el-col :span="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{l("查询")}}</el-button
          >
        </el-col>
      </el-row>

      <el-tabs v-model="SearchData.tag_id" type="card">
        <el-tab-pane
          v-for="item in tagList"
          :key="String(item.id)"
          :label="item.name"
          :name="String(item.id)"
        >
        </el-tab-pane>
      </el-tabs>

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) => true,
              label: '编辑',
              command: 'EditItem',
            },
            {
              is_show: (row) => true,
              label: '删除',
              command: 'DeleteItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column prop="name" :label="l('名称')"></el-table-column>
        <el-table-column label="logo">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                :src="scope.row.logo"
                fit="contain"
                :preview-src-list="[scope.row.logo]"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="order_index" label="优先级"></el-table-column>
        <el-table-column
          prop="description"
          label="简介"
          width="300"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditAdminGoodBusiness from "./operation/CreateOrEditAdminGoodBusiness.vue";

export default {
  name: "AdminGoodBusiness",
  components: {
    CreateOrEditAdminGoodBusiness,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        tag_id: "",
        name: "",
      },
      tagList: [],
    };
  },
  watch: {
    "SearchData.tag_id"() {
      this.GetTableList(true);
    },
  },
  mounted() {
    this.axios
      .get("/api/tag/", {
        params: {
          module: "good_business",
          size: 99,
          page: 1,
        },
      })
      .then((data) => {
        this.tagList = data.results;
        this.SearchData.tag_id = String(this.tagList[0].id);
      });
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/admin_good_business/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    CreateItem() {
      this.$refs.createOrEditDialog.Type = "Create";
      this.$refs.createOrEditDialog.Show({
        tag_id: Number(this.SearchData.tag_id),
      });
    },
    DeleteItem(item) {
      this.$confirm(`是否删除${item.name}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .delete(`/api/admin_good_business/${item.id}/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    RandomIndex(){
      this.$confirm(`是否随机排序所有优先级0~999999的优选好商?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/admin_good_business/random_index/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    }
  },
};
</script>


<style scoped lang="scss">
</style>

